import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  Button, TextInput, SelectInput, Flex, FlexColumn, Table, useStickySafeNavigate, useRematchDispatch,
} from '@equifinance/shared';
import Page from '../components/Page';
import { Referral } from '../models/referralsModel';
import { RootState } from '../store';

const Container = styled(FlexColumn)`
  width:100%;
`;
const ReferralButton = styled(Button)`${({ theme }) => `
  margin-right:${theme.padding[2]};
`}`;
const TextInputStyles = css`
  padding-top:0;
`.toString();

export default function Referrals() {
  const dispatch = useRematchDispatch();
  const navigate = useStickySafeNavigate();

  const referrals = useSelector((state: RootState) => state.referrals);
  const [referralTitle, setReferralTitle] = useState<string>('');
  const [referralDescription, setReferralDescription] = useState<string>('');

  const Buttons = (referral: Referral) => useMemo(
    () => (
      <>
        <ReferralButton onClick={() => navigate(`/referral-reasons/${referral.id}`)}>View Reasons</ReferralButton>
        <ReferralButton onClick={() => {}}>Submit</ReferralButton>
      </>
    ),
    [referral],
  );

  const StatusSelect = (referral: Referral) => useMemo(
    () => (
      <SelectInput
        id={`select-assignee-${referral.id}`}
        value={referral.status}
        options={{
          0: 'Incomplete',
          1: 'Complete',
        }}
        onChange={(value: string) => {
          dispatch.referrals.UPDATE({ status: value }, referral.id);
        }}
      />
    ),
    [referral],
  );

  const columns = [
    {
      name: 'Title',
      sortable: true,
      selector: (referral: Referral) => referral.title,
    },
    {
      name: 'Description',
      sortable: true,
      selector: (referral: Referral) => referral.description,
    },
    {
      name: 'Status',
      sortable: true,
      cell: (referral: Referral) => StatusSelect(referral),
    },
    {
      name: '',
      sortable: false,
      cell: (referral: Referral) => Buttons(referral),
    },
  ];

  const onClickCreateReferral = async () => {
    const referralId = await dispatch.referrals.createReferral({
      referral: {
        title: referralTitle,
        description: referralDescription,
      },
    });

    navigate(`/referral-reasons/${referralId}`);
  };

  return (
    <Page>
      <Container>
        <Flex>
          <TextInput styles={TextInputStyles} id="referral-title" placeholder="Title" value={referralTitle} onChange={setReferralTitle} />
          <TextInput styles={TextInputStyles} id="referral-description" placeholder="Description" value={referralDescription} onChange={setReferralDescription} />
          <Button onClick={onClickCreateReferral}>Create Referral</Button>
        </Flex>

        <Table
          columns={columns}
          data={Object.values(referrals)}
        />
      </Container>
    </Page>
  );
}
